import { objectToQuery } from '@axmit/transport';
import axios from 'axios';
import { IEntryGetRequest } from 'entities/Entries/entries.model';

export const entryGetTransport = (params: IEntryGetRequest) => axios.get('entry' + objectToQuery(params));
